import { ProfessionIcon } from './profession-icon';

export const IconHairStylist = () => (
  <ProfessionIcon bg="#FCE4EC">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 21l4-9-4-3V3"
        stroke="#E91E63"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 21l-4-9 4-3V3"
        stroke="#E91E63"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="15" r="2" stroke="#E91E63" strokeWidth="1.8" />
    </svg>
  </ProfessionIcon>
);
